import React, {forwardRef, useEffect, useImperativeHandle, useState} from 'react';
import {Card, CardBody, CardTitle, Col, Collapse, Form, FormGroup, Row,} from 'reactstrap';

import {
    ARE_YOU_SHURE_MSG,
    ARE_YOU_SHURE_TITLE,
    deleteErrorMsg,
    deleteMsg,
    error,
    LIST,
    NO,
    warning,
    YES,
} from "../../../components/i18n/i18n";
import {showToastCustom} from "../../../components/toast/customToast";
import {confirmAlert} from "react-confirm-alert";
import {utilHelper} from "../../../jwt/_helpers";
import {
    ButtonClean,
    ButtonSearch,
    ButtonTableDelete, ButtonTableEdit,
    ButtonTableFilter
} from "../../../components/buttons/buttonsActions";
import {showLoader} from "../../../components/loader/loader";
import BootstrapTable from "react-bootstrap-table-next";
import Select, {makeAnimated} from "react-select";
import {useForm} from "react-hook-form";
import {tabOptionProvider} from "../../../providers/tabOptionProvider";
import {promotionTabOptionService} from "../../../jwt/_services/relations/promotionTabOptionService";
import {ActiveFormatter} from "../../../components/tables/activeFormater";

export const PromotionTabOptionList = forwardRef((props, ref) => {
    const animatedComponents = makeAnimated();

    const [promotion] = useState(props.promotion);

    const [collapsed, setCollapsed] = useState(false);
    const [listItems, setListItems] = useState([]);
    const [loading, setLoading] = useState(false);

    const [tabOptionOptions, setTabOptionOptions] = useState([]);
    const [tabOption, setTabOption] = useState(undefined);

    useEffect(() => {
        tabOptionProvider.getOptions()
            .then(result => {
                if (result){
                    setTabOptionOptions(result);
                }
                else{
                    setTabOptionOptions([]);
                }
                setLoading(false);
            })
            .catch(errorMessage => {
                setLoading(false);
                setTabOptionOptions([]);
                showToastCustom(error, errorMessage);
            });

        const dataRequest = {
            promotion: {id: promotion?.id},
            tabOption: {id: null}
        };

        refreshDataList(dataRequest);
    }, []);

    const handleTableChange = () => {
        const dataRequest = {
            promotion: {id: promotion?.id},
            tabOption: {id: (tabOption?.id ? tabOption.id : null)}
        };

        refreshDataList(dataRequest);
    };

    const refreshDataList = (dataRequest) => {
        setLoading(true);
        setListItems([]);

        promotionTabOptionService.search(0,1000, dataRequest)
            .then(result => {
                setLoading(false);
                if (result){
                    setListItems(mapResult(result));
                }else {
                    setListItems([]);
                }
            })
            .catch(errorMessage => {
                setLoading(false);
                setListItems([]);
                showToastCustom(error, errorMessage);
            });
    }

    const mapResult = (result) => {
        let mappedList = [];

        result.map((promoTabOption) => {
            const item = {
                id: promoTabOption.id,
                uid: promoTabOption.uid,
                code: promoTabOption.tabOption?.code ? promoTabOption.tabOption?.code : "",
                status: promoTabOption.status,
                tabOption : promoTabOption.tabOption,
                promotion : promoTabOption.promotion,
            }

            mappedList.push(item);
        });

        return mappedList;
    }

    useImperativeHandle(ref, () => ({
        refreshList() {
            const dataRequest = {
                promotion: {id: promotion?.id},
                tabOption: {id: (tabOption?.id ? tabOption.id : null)}
            };

            refreshDataList(dataRequest);
        }
    }));

    // ----------------------------------------------
    //            SEARCH FILTERS FORM
    // ----------------------------------------------
    const {handleSubmit, reset} = useForm({});

    const onSubmit = (data, _) => {
        const dataRequest = {
            promotion: {id: promotion?.id},
            tabOption: {id: (tabOption?.id ? tabOption.id : null)}
        };

        refreshDataList(dataRequest);
    };

    const showFilters = () => setCollapsed(!collapsed);

    const cleanFields = () => {
        setLoading(true);
        reset();
        setTabOption(null);

        const dataRequest = {
            promotion: {id: promotion?.id},
            tabOption: {id: null}
        };

        refreshDataList(dataRequest);
    }

    // ----------------------------------------------
    //            TABLE BUTTONS
    // ----------------------------------------------
    const editItem = (data) => {
        const itemToEdit = listItems.find(n => n.id === data.id);
        props.setForm(true, itemToEdit);
    }

    const confirmDelete = (data) => {
        return confirmAlert({
            closeOnEscape: true,
            closeOnClickOutside: true,
            customUI: ({onClose}) => {
                return (
                    <div className='custom-ui'>
                        <h1>{ARE_YOU_SHURE_TITLE}</h1>
                        <p>{ARE_YOU_SHURE_MSG}</p>
                        <button onClick={onClose}>{NO}</button>
                        <button className={"btn-alert-delete"} onClick={() => {
                            deleteItem(data)
                            onClose();
                        }}>
                            {YES}
                        </button>
                    </div>
                );
            }
        });
    };

    const deleteItem = (data) => {
        setLoading(true);
        promotionTabOptionService.deleteItem(data.id)
            .then(_ => {
                setLoading(false);

                const dataRequest = {
                    promotion: {id: promotion?.id},
                    benefit: {id: null}
                };

                refreshDataList(dataRequest);

                if (utilHelper.hasAssociateRecords())
                    utilHelper.restartAssociateRecords();
            });
    }

    // ----------------------------------------------
    //            CHANGE HANDLERS
    // ----------------------------------------------
    const onTabOptionChange = (value) => setTabOption(value);

    // ----------------------------------------------
    //            ROW FORMATTERS
    // ----------------------------------------------
    const activeFormatter = (cell) => <ActiveFormatter active={cell}/>

    const actionsFormatter = (cell, row) => <>
        <ButtonTableEdit onClick={() => editItem(row)}/>
        <ButtonTableDelete onClick={() => confirmDelete(row)}/>
    </>

    const columns = [
        {
            dataField: 'id',
            headerStyle: {width: '0px'},
            text: 'ID',
            hidden: true
        }, {
            dataField: 'uid',
            text: 'Firebase Id',
            sort: true,
            headerStyle: {width: '200px'},
        }, {
            dataField: 'code',
            text: 'Codigo de la opción',
            sort: true
        }, {
            dataField: 'status',
            text: "Activo",
            headerAlign: 'center',
            align: 'center',
            headerStyle: {width: '70px'},
            formatter: activeFormatter
        }, {
            isDummyField: true,
            text: 'Acción',
            headerStyle: {width: '140px'},
            headerAlign: 'center',
            align: 'center',
            formatter: actionsFormatter
        }
    ];

    return <>
        <Card>
            <CardTitle className="bg-light border-bottom p-3 mb-0">
                <i className="far fa-list-alt mr-2"> </i>{LIST}
                <div className="float-right">
                    <ButtonTableFilter onClick={() => showFilters()} collapsed={collapsed}/>
                </div>
            </CardTitle>
            <Collapse isOpen={collapsed}>
                <Form onSubmit={handleSubmit(onSubmit)}>
                    <CardBody className="">
                        <Row>
                            <Col md="4">
                                <FormGroup>
                                    <Select name="benefit"
                                            value={tabOption}
                                            options={tabOptionOptions}
                                            components={animatedComponents}
                                            placeholder="Selecciona una opción"
                                            isSearchable={true}
                                            isClearable={true}
                                            onChange={onTabOptionChange}/>
                                </FormGroup>
                            </Col>
                            <Col md="8">
                                <div className="float-right">
                                    <ButtonSearch/>
                                    <ButtonClean onClick={() => cleanFields()}/>
                                </div>
                            </Col>
                        </Row>
                    </CardBody>
                </Form>
            </Collapse>
            <CardBody className="">
                {loading && showLoader()}
                <BootstrapTable
                    striped hover
                    tableHeaderClass='mb-0'
                    remote
                    keyField="id"
                    data={listItems}
                    columns={columns}
                    onTableChange={handleTableChange}
                />
            </CardBody>
        </Card>
    </>
});
